<template lang='pug'>
  .FormMezo.field(:class='classList')
    label.label(:for="html_id")
      span(v-html='mezo.label')
      span.colon :
    .control
      .hint {{mezo.hint}}
      .wrapper(:class='config.wrapper')
        .mezo(:is="config.element", :class='config.class' :type='mezo.type'
          v-bind='mezo.attrs'
          :value.prop='value' v-on:input="input($event.target.value)"
          :disabled='mezo.form.disabled' tabindex='0' :id="html_id")
          option(v-for='option in mezo.options', :value='option') {{option}}
      //.validation(v-if='mezo.state') {{mezo.state.message}}

</template>

<script>

  const config =
  {
    select: {
      element: 'select',
      class: '',
      wrapper: "select is-fullwidth",
      setup({mezo, input}) {
        mezo.options.length && input(mezo.options[0])
      }
    },
    textarea: {
      element: 'textarea',
      class: 'textarea',
    },
    checkbox: {
      element: 'input',
      wrapper: 'checkbox',
    },
    input: {
      element: 'input',
      class: 'input',
    }
  };

  export default {
    name: "FormMezo",
    props: ['model', 'mezo'],
    computed: {
      value() {
        return this.model[this.mezo.id]
      },
      config() {
        return config[this.mezo.type] || config.input
      },
      html_id() {
        return `formmezo_${this.mezo.id}`
      },
      classList() {
        return ["FormMezo-"+this.mezo.type, this.mezo.state ? "state-" + this.mezo.state.state: ""]
        }
    },
    mounted() {
      this.config.setup && this.config.setup(this)

    },
    methods: {
      input(value) {
        this.model[this.mezo.id] = value
      }
    }
  }
</script>

<style lang="sass">
@import '../app/vars'
.FormMezo
  .input[disabled], .textarea[disabled], select[disabled]
    
    color: #333

  .hint:not(:empty)
    padding: .1rem
    margin-bottom: .5rem
    margin-top: -.5rem
    font-size: .8rem
    
  &.state-error
    .input:not(:focus)
      border-color: $red
    .label
      color: $red
.FormMezo-checkbox
  display: flex
  align-items: baseline
  .label
    order: 1
  .control
    padding-right: .5rem
  .colon
    display: none
  
</style>